import React from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  Button,
  MobileStepper,
  ArrowRightIcon,
  ArrowLeftIcon,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const ProgressStepper = () => {
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Progress
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          Use a progress bar when there are many steps, or if there are steps
          that need to be inserted during the process (based on responses to
          earlier steps).
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              "" +
              "  const [activeStep, setActiveStep] = React.useState(0);\n" +
              "\n" +
              "  const handleNext = () => {\n" +
              "    setActiveStep((prevActiveStep) => prevActiveStep + 1);\n" +
              "  };\n" +
              "\n" +
              "  const handleBack = () => {\n" +
              "    setActiveStep((prevActiveStep) => prevActiveStep - 1);\n" +
              "  };" +
              "            <MobileStepper\n" +
              '              variant="progress"\n' +
              "              steps={6}\n" +
              '              position="static"\n' +
              "              activeStep={activeStep}\n" +
              "              sx={{ maxWidth: 400, flexGrow: 1 }}\n" +
              "              nextButton={\n" +
              "                <Button\n" +
              '                  variant="text"\n' +
              '                  size="small"\n' +
              "                  onClick={handleNext}\n" +
              "                  disabled={activeStep === 5}\n" +
              "                  endIcon={<ArrowRightIcon />}\n" +
              "                >\n" +
              "                  Next\n" +
              "                </Button>\n" +
              "              }\n" +
              "              backButton={\n" +
              "                <Button\n" +
              '                  variant="text"\n' +
              '                  size="small"\n' +
              "                  onClick={handleBack}\n" +
              "                  disabled={activeStep === 0}\n" +
              "                  startIcon={<ArrowLeftIcon />}\n" +
              "                >\n" +
              "                  Back\n" +
              "                </Button>\n" +
              "              }\n" +
              "            />"
            }
          >
            <MobileStepper
              variant="progress"
              steps={6}
              position="static"
              activeStep={activeStep}
              sx={{ maxWidth: 400, flexGrow: 1 }}
              nextButton={
                <Button
                  variant="text"
                  size="small"
                  onClick={handleNext}
                  disabled={activeStep === 5}
                  endIcon={<ArrowRightIcon />}
                >
                  Next
                </Button>
              }
              backButton={
                <Button
                  variant="text"
                  size="small"
                  onClick={handleBack}
                  disabled={activeStep === 0}
                  startIcon={<ArrowLeftIcon />}
                >
                  Back
                </Button>
              }
            />
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default ProgressStepper;
